import styles from './index.module.scss';

/**
 * 他へのページリンクコンポーネントのProps
 * @param title ページ名
 * @param description ページ説明
 * @param linkUrl ページリンクURL
 * @param imagePath 画像パス
 * @param onClick リンク押下時処理
 */
interface Props {
  title: string;
  description: string;
  linkUrl: string;
  imagePath: string;
  onClick?: () => void;
}

export const OtherPageLinkItem: React.FC<Props> = ({
  title,
  description,
  linkUrl,
  imagePath,
  onClick,
}) => {
  return linkUrl ? (
    <>
      <a className={styles.otherPageLinkItem} href={linkUrl} onClick={onClick}>
        <img
          className={styles.otherPageLinkItem__image}
          src={imagePath}
          alt={title}
        />
        <div className={styles.otherPageLinkItem__text}>
          <h3 className={styles['otherPageLinkItem__text--title']}>{title}</h3>
          <p className={styles['otherPageLinkItem__text--description']}>
            {description}
          </p>
        </div>
      </a>
    </>
  ) : (
    <></>
  );
};
